// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2_Aio","total":"Cart_total__RPOOK","actions":"Cart_actions__3zJ53","button--alt":"Cart_button--alt__22viz","button":"Cart_button__2sQ4w"};